var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.73037C12.4086 4.33951 8.42338 4.42625 5.9331 6.99057C3.35564 9.64466 3.35564 13.9478 5.9331 16.6019L13.4444 24.3365C14.3035 25.2212 15.6965 25.2212 16.5556 24.3365L24.0669 16.6019C26.6444 13.9478 26.6444 9.64466 24.0669 6.99057C21.5766 4.42625 17.5914 4.33951 15 6.73037ZM13.7113 8.59246L14.2222 9.11856C14.6518 9.56091 15.3482 9.56091 15.7778 9.11856L16.2887 8.59246C18.007 6.82306 20.793 6.82306 22.5113 8.59246C24.2296 10.3618 24.2296 13.2306 22.5113 15L15 22.7346L7.48873 15C5.77042 13.2306 5.77042 10.3618 7.48873 8.59246C9.20704 6.82306 11.993 6.82306 13.7113 8.59246Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favorite-icon.763470207f2a9102039f16206a501b4e.svg";
export { ForwardRef as ReactComponent };